//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    productName: { type: String, required: true },
    subtitle: { type: String, default: '' },
    price: { type: Number, required: true },
    discount: { type: Number, default: 0 },
    isMinimumPrice: { type: Boolean, default: false },
    size: { type: String, validator: val => ['regular', 'small'].includes(val), default: 'regular' },
    subtitleAboveTitle: { type: Boolean, default: true },
    renderEmptySubtitle: { type: Boolean, default: true }
  },
  computed: {
    productNameParts () {
      const match = this.productName.match(/^(.+?) <sp.+?>(.+?)</m)
      return match ? [match[1], match[2]] : null
    },
    strippedProductName () {
      // Don't alter the product name if we've already got a subtitle
      if (this.subtitle || !this.productNameParts) return this.productName
      return this.productNameParts[0]
    },
    expandedSubtitle () {
      // Don't alter the product name if we've already got a subtitle
      if (this.subtitle || !this.productNameParts) return this.subtitle
      return this.productNameParts[1]
    }
  }
}
